export enum PressReleaseListingType {
  Standard = 1,
  Promoted = 2
}
